import { ref } from "firebase/database";
import { database } from "../firebase/firebaseConfig";

export const usersDbRef = ref(database, "Users");
export const enquiriesDbRef = ref(database, "Enquiries");
export const jobRequestsDbRef = ref(database, "JobRequests");